import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFileAddComponent } from "./med-icon-file-add.component";

@NgModule({
  declarations: [
    MedIconFileAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFileAddComponent,
  ],
})
export class MedIconFileAddModule { }
